module.exports = __webpack_public_path__ + "static/media/medimart.83a67043.png";